export default __webpack_public_path__ + "2e7414733cbee1d5eefd40a49216e5cd.png";